import * as React from "react";
import * as ReactDOM from "react-dom";

import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./UserInfo.scss";


export interface IUserInfoProps {
    /** class */
    className?: string;
}
export interface IUserInfoState {
    userName:string
}
@pureRender
export class UserInfo extends React.Component<IUserInfoProps, IUserInfoState>{
    constructor(props) {
        super(props);
        this.state = {
            userName:""
        }
    }

    componentWillMount(){
        window.Global.isLogin(()=>{
            f2eGame.port.udb.getUserInfo()
            .then((res:any)=>{
                this.setState({
                    userName:res.nickName
                })
            })
        })
    }
    public render() {
        const { className } = this.props;
        const classNameSec = classnames(styles.sec, className);
       
        return (
            <div className={classNameSec}>
                {this.renderInfo()}
                
            </div>

        )
    }
    private renderInfo=()=>{
        let {userName}=this.state;
        if(!!userName){
            return(
                <div className={styles.logoutneara}>
                    <span className={styles.username}>{userName}</span>
                    <a className={styles.logout} onClick={(e)=>f2eGame.port.udb.logout()}>注销</a>
                </div>
            )
        }else{
            return(
                <div className={styles.logineara}>
                    <a className={styles.login} onClick={(e)=>f2eGame.port.udb.login({
                        type:"YYQ"
                    })}>登录</a>                    
                </div>
            )
        }
    }
}

export default UserInfo;


// WEBPACK FOOTER //
// ./src/components/UserInfo/UserInfo.tsx